// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImageCropperSlider__slider-c3ec71 {
  position: relative;
  width: 200px;
  height: 4px;
}

.ImageCropperSlider__dot-ea2a8f {
  height: 4px;
  background-color: var(--brand-primary-40);
  position: absolute;
  top: 10px;
  z-index: 1;
  border-radius: 4px;
  pointer-events: none;
}

.ImageCropperSlider__input-e69f70 {
  background-color: var(--base-60);
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
}

.ImageCropperSlider__input-e69f70::-webkit-slider-runnable-track {
  height: 4px;
  border: none;
  border-radius: 2px;
  outline: none;
  background: var(--base-40);
}

.ImageCropperSlider__input-e69f70::-moz-range-track {
  height: 4px;
  border: none;
  border-radius: 2px;
  outline: none;
  background: var(--base-40);
}

.ImageCropperSlider__input-e69f70::-webkit-slider-thumb {
  -webkit-appearance: none;
  border: none;
  height: 16px;
  width: 16px;
  border-radius: 100%;
  background: var(--brand-primary-40);
  margin-top: -6px;
  z-index: 2;
  position: relative;
}

.ImageCropperSlider__input-e69f70::-moz-range-thumb {
  -webkit-appearance: none;
  border: none;
  height: 16px;
  width: 16px;
  border-radius: 100%;
  background: var(--brand-primary-40);
  margin-top: -6px;
  z-index: 2;
  position: relative;
}

.ImageCropperSlider__input-e69f70:focus {
  outline: none !important;
}

.ImageCropperSlider__input-e69f70:active {
  outline: none !important;
}

.ImageCropperSlider__input-e69f70::-moz-focus-outer {
  border: 0;
}

.ImageCropperSlider__filled-bc92ca {
  height: 100%;
  background-color: var(--brand-primary-30);
  position: absolute;
  z-index: 1;
  border-radius: 4px;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/ImageCropper/ImageCropperSlider/ImageCropperSlider.style.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;EACA,yCAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;AACF;;AAEA;EACE,gCAAA;EACA,eAAA;EACA,wBAAA;EACA,gBAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,0BAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,0BAAA;AACF;;AAEA;EACE,wBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,mCAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;AACF;;AAEA;EACE,wBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,mCAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,YAAA;EACA,yCAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;AACF","sourcesContent":[".slider {\n  position: relative;\n  width: 200px;\n  height: 4px;\n}\n\n.dot {\n  height: 4px;\n  background-color: var(--brand-primary-40);\n  position: absolute;\n  top: 10px;\n  z-index: 1;\n  border-radius: 4px;\n  pointer-events: none;\n}\n\n.input {\n  background-color: var(--base-60);\n  cursor: pointer;\n  -webkit-appearance: none;\n  appearance: none;\n  width: 100%;\n}\n\n.input::-webkit-slider-runnable-track {\n  height: 4px;\n  border: none;\n  border-radius: 2px;\n  outline: none;\n  background: var(--base-40);\n}\n\n.input::-moz-range-track {\n  height: 4px;\n  border: none;\n  border-radius: 2px;\n  outline: none;\n  background: var(--base-40);\n}\n\n.input::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  border: none;\n  height: 16px;\n  width: 16px;\n  border-radius: 100%;\n  background: var(--brand-primary-40);\n  margin-top: -6px;\n  z-index: 2;\n  position: relative;\n}\n\n.input::-moz-range-thumb {\n  -webkit-appearance: none;\n  border: none;\n  height: 16px;\n  width: 16px;\n  border-radius: 100%;\n  background: var(--brand-primary-40);\n  margin-top: -6px;\n  z-index: 2;\n  position: relative;\n}\n\n.input:focus {\n  outline: none !important;\n}\n\n.input:active {\n  outline: none !important;\n}\n\n.input::-moz-focus-outer {\n  border: 0;\n}\n\n.filled {\n  height: 100%;\n  background-color: var(--brand-primary-30);\n  position: absolute;\n  z-index: 1;\n  border-radius: 4px;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"slider": `ImageCropperSlider__slider-c3ec71`,
	"dot": `ImageCropperSlider__dot-ea2a8f`,
	"input": `ImageCropperSlider__input-e69f70`,
	"filled": `ImageCropperSlider__filled-bc92ca`
};
module.exports = ___CSS_LOADER_EXPORT___;
